import { render, staticRenderFns } from "./MoreDetails.vue?vue&type=template&id=cecff630&scoped=true&"
import script from "./MoreDetails.vue?vue&type=script&lang=js&"
export * from "./MoreDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecff630",
  null
  
)

export default component.exports